import { GET, POST, PATCH, DELETE } from "../config";

export const list = async ({
  page = 1,
  branch = null,
  start_date = null,
  end_date = null,
  search = "",
  order_type = null,
  payment_status = null,
  page_size = 10,
} = {}) => {
  const params = new URLSearchParams();
  params.append("page", page);
  params.append("page_size", page_size);
  if (branch) params.append("branch", branch);
  // ✅ CORREGIDO: Usar start_date y end_date (filtros personalizados que filtran por fecha completa)
  if (start_date) params.append("start_date", start_date);
  if (end_date) params.append("end_date", end_date);
  if (search) params.append("search", search);
  if (order_type) params.append("order_type", order_type);
  if (payment_status) params.append("payment_status", payment_status);

  const response = await GET(`sales/orders/?${params.toString()}`);
  return response.data;
};

export const retrieve = async (id) => {
  const response = await GET(`sales/orders/${id}/`);
  return response.data;
};

export const get = retrieve; // Alias

export const create = async (data) => {
  const response = await POST("sales/orders/", data);
  return response.data;
};

export const update = async (id, data) => {
  const response = await PATCH(`sales/orders/${id}/`, data);
  return response.data;
};

export const destroy = async (id) => {
  const response = await DELETE(`sales/orders/${id}/`);
  return response.data;
};

// Generar PDF de orden
export const generatePDF = async (id) => {
  const response = await GET(`sales/orders/${id}/generate_pdf/`, {
    responseType: "blob",
  });
  // Crear un link para descargar
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", `orden_${id}.pdf`);
  document.body.appendChild(link);
  link.click();
  link.remove();
  return response;
};

// Actualizar estado de pago
export const updatePaymentStatus = async (id, data) => {
  const response = await PATCH(
    `sales/orders/${id}/update_payment_status/`,
    data
  );
  return response.data;
};

// Obtener documento tributario de una orden
export const getTaxDocument = async (id) => {
  const response = await GET(`sales/orders/${id}/tax_document/`);
  return response.data;
};

// Generar boleta PDF formato 80mm (comprobante de pago)
export const generateBoletaPdf = async (id) => {
  const token = localStorage.getItem("token");
  const configModule = await import("../config");
  const Axios = configModule.Axios;
  
  console.log("[API] Generando boleta PDF para orden:", id);
  
  try {
    const response = await Axios.get(`sales/orders/${id}/generate-boleta-pdf/`, {
      headers: {
        Authorization: `Token ${token}`,
      },
      responseType: 'blob',
      timeout: 30000, // 30 segundos de timeout
    });
    
    console.log("[API] Respuesta recibida, tipo:", response.headers['content-type']);
    console.log("[API] Tamaño de datos:", response.data?.size || 'N/A');
    
    return response;
  } catch (error) {
    console.error("[API] Error en generateBoletaPdf:", error);
    // Si el error es un blob (error del servidor), intentar parsearlo
    if (error.response && error.response.data instanceof Blob) {
      const text = await error.response.data.text();
      try {
        const errorData = JSON.parse(text);
        error.response.data = errorData;
      } catch (e) {
        // Si no es JSON, mantener el blob
      }
    }
    throw error;
  }
};

// Generar boleta domiciliaria PDF formato A4 (boleta que llega a casa)
export const generateBoletaDomiciliariaPdf = async (id) => {
  const token = localStorage.getItem("token");
  const configModule = await import("../config");
  const Axios = configModule.Axios;
  
  console.log("[API] Generando boleta domiciliaria PDF para orden:", id);
  
  try {
    const response = await Axios.get(`sales/orders/${id}/generate-boleta-domiciliaria-pdf/`, {
      headers: {
        Authorization: `Token ${token}`,
      },
      responseType: 'blob',
      timeout: 30000, // 30 segundos de timeout
    });
    
    console.log("[API] Respuesta recibida, tipo:", response.headers['content-type']);
    console.log("[API] Tamaño de datos:", response.data?.size || 'N/A');
    
    return response;
  } catch (error) {
    console.error("[API] Error en generateBoletaDomiciliariaPdf:", error);
    // Si el error es un blob (error del servidor), intentar parsearlo
    if (error.response && error.response.data instanceof Blob) {
      const text = await error.response.data.text();
      try {
        const errorData = JSON.parse(text);
        error.response.data = errorData;
      } catch (e) {
        // Si no es JSON, mantener el blob
      }
    }
    throw error;
  }
};

// Endpoints para productos de orden (OrderProduct)
// Usa el endpoint real: sales/order-products/
const order_register_product = async (data) => {
  const response = await POST("sales/order-products/", data);
  return response.data;
};

const order_update_register_product = async (id, data) => {
  const response = await PATCH(`sales/order-products/${id}/`, data);
  return response.data;
};

const order_destroy_register_product = async (id) => {
  const response = await DELETE(`sales/order-products/${id}/`);
  return response.data;
};

const order_list_register_product = async (page = 1, filters = {}) => {
  const params = new URLSearchParams();
  params.append("page", page);
  Object.keys(filters).forEach((key) => {
    if (filters[key] !== null && filters[key] !== undefined) {
      params.append(key, filters[key]);
    }
  });
  const response = await GET(`sales/order-products/?${params.toString()}`);
  return response.data;
};

const bulk_create = async (data) => {
  // Para bulk create, crear productos individualmente
  const results = await Promise.all(
    data.map((item) => order_register_product(item))
  );
  return results;
};

export const register_products = {
  create: order_register_product,
  update: order_update_register_product,
  destroy: order_destroy_register_product,
  list: order_list_register_product,
  bulk_create: bulk_create,
};

/**
 * Obtener arqueo de caja según el rol del usuario
 * @param {string} date - Fecha específica (YYYY-MM-DD), opcional
 * @param {string|number} branch - ID de sucursal, opcional
 * @returns {Promise} Resumen de arqueo por rol
 */
export const getArqueo = async (date = null, branch = null) => {
  const params = new URLSearchParams();
  if (date) {
    params.append("date", date);
  }
  if (branch) {
    params.append("branch", branch);
  }

  const url = params.toString() 
    ? `sales/orders/arqueo/?${params.toString()}`
    : "sales/orders/arqueo/";

  const response = await GET(url);
  return response.data;
};
